import {
  ACORN_PROJECT_NAME,
  SESSIONS_STORAGE_KEY,
} from '@web-platform/shared-universal-constants/src/project';
import { LocalStorage } from 'saddlebag-localstorage';

import { isAcornRequest } from './isAcornRequest';
import { logWarn } from './logger';

type LocalStorageOptions = {
  useCookie?: boolean;
  namespace?: string;
};
const namespacedStorages: Record<string, InstanceType<typeof LocalStorage>> = {};

const getDefaultNamespace = (): string =>
  isAcornRequest() ? ACORN_PROJECT_NAME : SESSIONS_STORAGE_KEY;

const getStorage = (namespace: string) => {
  namespacedStorages[namespace] = namespacedStorages[namespace] ?? new LocalStorage(namespace);
  return namespacedStorages[namespace];
};

export function tryGetValue<T>(
  key: string,
  defaultValue: T,
  { namespace = getDefaultNamespace(), useCookie = false }: LocalStorageOptions = {},
): T {
  try {
    return getStorage(namespace).tryGetValue(key, useCookie, true) ?? defaultValue;
  } catch (error) {
    logWarn({
      component: 'sessionStorage',
      message: error.message,
      stacktrace: error.stack,
    });
    return defaultValue;
  }
}
export const trySetValue = (
  key: string,
  value: unknown,
  { namespace = getDefaultNamespace(), useCookie = false }: LocalStorageOptions = {},
) => {
  try {
    getStorage(namespace).trySetValue(key, value, useCookie, true);
  } catch (error) {
    logWarn({
      component: 'sessionStorage',
      message: error.message,
      stacktrace: error.stack,
    });
  }
};
